import React, { useState } from 'react';
import { MARCHE_TAKATA } from '../../data/takataMarche';

// Logo di una marca, con ripiego sulle iniziali.
//
// Nasce nella pagina di raccolta telai, dove stava fino al 29/07/2026, ed è stato estratto
// per usarlo anche nello stato dei portali: un elenco di trenta marchi tutto uguale si
// legge male, mentre il marchio si riconosce a colpo d'occhio.
//
// I file stanno in public/images/takata-marchi/<slug>.jpg. Non tutte le marche ne hanno
// uno, e un file può sempre mancare: in quel caso si mostrano le iniziali invece di
// lasciare l'icona di immagine rotta.

interface Props {
  /** Nome della marca come arriva dal server (es. «Mercedes-Benz», «land rover»). */
  nome: string;
  /** Dimensione in pixel del lato. */
  size?: number;
}

// Dal nome si risale allo slug del file: il server manda «Mercedes-Benz» o «mercedes-benz»
// a seconda del percorso, l'elenco dei marchi tiene la corrispondenza.
function slugDiMarca(nome: string): string | undefined {
  const k = String(nome || '').trim().toLowerCase();
  const trovata = MARCHE_TAKATA.find((m) => m.nome.toLowerCase() === k || m.slug === k);
  return trovata?.slug;
}

const LogoMarca: React.FC<Props> = ({ nome, size = 40 }) => {
  const [err, setErr] = useState(false);
  const slug = slugDiMarca(nome);
  const stile = { width: size, height: size };

  if (slug && !err) {
    return (
      <img
        src={`/images/takata-marchi/${slug}.jpg`}
        alt={nome}
        onError={() => setErr(true)}
        style={stile}
        className="object-contain flex-shrink-0 rounded bg-white"
      />
    );
  }
  return (
    <div
      style={stile}
      className="rounded bg-gray-200 dark:bg-gray-700 flex items-center justify-center text-2xs font-bold text-gray-600 dark:text-gray-300 flex-shrink-0"
    >
      {String(nome || '?').slice(0, 3).toUpperCase()}
    </div>
  );
};

export default LogoMarca;
